/**
 * Student Invoice & Finance Models
 * Portal-specific models for viewing invoices, positions, and installments
 */

export enum InvoiceStatusId {
  Planned = 650,
  ToSend = 651,
  Sent = 652,
  Cancelled = 653,
  Paused = 654,
  Aborted = 655,
}

export type InstallmentStatus = 'paid' | 'overdue' | 'to_pay';

export interface StudentInvoicePosition {
  invoice_position_id: number;
  fk_invoice_id?: number | null;
  position?: number | null;
  description?: string | null;
  quantity?: number | null;
  amount_net: number;
  vat_pct?: number | null;
  amount_vat?: number | null;
  amount_gross?: number | null;
  price_code_short?: string | null;
  price_code_long?: string | null;
}

export interface StudentInvoicePayment {
  installment_payment_id: number;
  amount: number;
  match_date?: string | null;
  payment_date?: string | null;
  fk_invoice_installment_id: number;
}

export interface StudentInvoiceInstallment {
  invoice_installment_id: number;
  installment_no: number;
  amount: number;
  open_amount: number;
  due_date: string;
  reminder_level?: number | null;
  fk_status_id?: number | null;
  esr_reference?: string | null;
  payments?: StudentInvoicePayment[] | null;
}

export interface StudentInvoice {
  invoice_id: number;
  fk_school_id?: number | null;
  school_shortname?: string | null;
  fk_contact_id?: number | null;
  contact_name?: string | null;
  fk_invoice_type_id?: number | null;
  invoice_type?: string | null;
  fk_status_id: number;
  status?: string | null;
  invoice_date: string;
  due_date: string;
  amount_net: number;
  amount_vat: number;
  amount_gross: number;
  open_amount: number;
  paid_amount?: number;
  fk_degree_id?: number | null;
  degree_code?: string | null;
  fk_module_id?: number | null;
  module_code?: string | null;
  pdf_url?: string | null;
  positions?: StudentInvoicePosition[];
  installments?: StudentInvoiceInstallment[];
}

export interface StudentInvoiceDetailResponse {
  invoice_id: number;
  fk_status_id: number;
  invoice_status: string;
  invoice_date: string;
  due_date: string;
  degree_code?: string | null;
  module_code?: string | null;
  positions: StudentInvoicePosition[];
  installments: StudentInvoiceInstallment[];
}

export interface InvoiceSearchResponse {
  results: StudentInvoice[];
  total_count: number;
  has_more: boolean;
  stats?: Record<string, number>;
}

export interface StudentInstallmentStatus {
  school_id: number;
  school_name: string;
  school_shortname?: string | null;
  installments_type?: string | null;
  installments_value?: number | null;
  has_installments_enabled: boolean;
  planned_invoices_count: number;
}

